<template>
  <div class="p-g01-item-list-header">
    <div class="p-g01-item-list-header__info">
      <template v-if="isCategory">
        <IconItemCategory :id="id" class="p-g01-item-list-header__info__icon" />
        <p class="p-g01-item-list-header__info__label">{{ label }}</p>
      </template>
      <template v-else>
        <IconPoint :icon-size="24" class="p-g01-item-list-header__info__icon" />
        <p
          class="p-g01-item-list-header__info__label p-g01-item-list-header__info__label--point"
        >
          {{ label }}
        </p>
      </template>
    </div>
    <template v-if="isCategory">
      <div class="p-g01-item-list-header__button">
        <ButtonMain
          :tag="'button'"
          @click-button="goToProductList()"
          kind="secondary"
          >このカテゴリーの商品をもっと見る</ButtonMain
        >
      </div>
    </template>
  </div>
</template>

<script lang="ts">
import IconItemCategory from "@/common/components/icons/IconItemCategory.vue";
import IconPoint from "@/common/components/icons/IconPoint.vue";
import ButtonMain from "@/common/components/atoms/ButtonMain.vue";
import { Options, Vue } from 'vue-class-component';
import commons from "@/common/store/modules/commons";
import LocalStorage from "@/general/utils/storage";

@Options({
  props: {
    id: { type: String, required: true, default: "" },
    label: { type: String, required: true, default: "" },
    isCategory: { type: Boolean, required: true, default: true },
    isFirst: { type: Boolean, required: false, default: false }
  },
  components: {
    IconItemCategory,
    IconPoint,
    ButtonMain
  }
})
export default class G01ItemListGroupHeader extends Vue {
  id!: string;
  label!: string;
  isCategory!: boolean;
  isFirst!: boolean;

  get unit() {
    return commons?.OrgPageSpecific?.point_name;
  }
  get isPointRangeFirst() {
    return this.id === "item-point-range0";
  }
  get isPointRangeLast() {
    return this.id === "item-point-range5";
  }

  goToProductList() {
    LocalStorage.setItem("productListSort", "popularity");
    window.location.href = "/product-list/?product-category=" + this.id;
  }
}
</script>

<style lang="scss" scoped>
.p-g01-item-list-header {
  max-width: rem(1200);
  padding-top: 24px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @include large-pc {
    border-top: px(1) solid $common-gray-border;
  }

  &__info {
    display: flex;
    align-items: center;

    &__label {
      font-size: $text-size__title--s;
      font-weight: bold;

      &--point {
        font-family: $font--roboto;
      }
    }

    &__icon {
      margin-right: rem(8);
    }
  }

  &__button {
    @include large-sp {
      display: none;
    }
  }
}
</style>
